import type { Cadence } from "../../utils/reportTypes"
import { Choice } from "./ReportControls"

const ONCE = "once"
const PERIOD: Record<Cadence, string> = {
  daily: "day",
  weekly: "week",
  monthly: "month",
}

/** Whether a new notebook repeats, chosen alongside the period it covers. */
export function ReportRepeatPicker({
  value,
  onChange,
  automatic,
  disabled,
  cadences = ["daily", "weekly", "monthly"],
}: {
  value: Cadence | null
  onChange: (value: Cadence | null) => void
  /** Whether this deployment runs saved schedules on its own. */
  automatic: boolean
  disabled: boolean
  /** The cadences this environment can schedule. */
  cadences?: Cadence[]
}) {
  const period = value ? PERIOD[value] : null
  return (
    <Choice
      label="Repeat"
      description={
        !period
          ? "A one-time notebook for the dates above."
          : automatic
            ? `Starts with the dates above, then Sofia adds a new notebook every ${period} covering the ${period} that just ended.`
            : `Starts with the dates above and saves the schedule. Automatic runs are not on here yet, so generate each new ${period} from Schedules.`
      }
      value={value ?? ONCE}
      onChange={(next) => onChange(next === ONCE ? null : (next as Cadence))}
      options={[
        { value: ONCE, label: "Does not repeat" },
        ...cadences.map((cadence) => ({
          value: cadence,
          label: `Every ${PERIOD[cadence]}`,
        })),
      ]}
      disabled={disabled}
    />
  )
}
